"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var LOADING_WITH_COLOR_MODE = {
  PICKED_COLOR: 'PICKED_COLOR',
  MAIN_COLOR: 'MAIN_COLOR'
};
var _default = LOADING_WITH_COLOR_MODE;
exports["default"] = _default;